var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "floor-plan-canvas" },
    [
      _c("img", {
        ref: "floorPlanImage",
        staticClass: "floor-plan-image",
        attrs: {
          src: _vm.floorPlan.image_url,
          alt: _vm.floorPlan.name,
          crossorigin: "anonymous",
        },
        on: { load: _vm.onImageLoad },
      }),
      _vm._v(" "),
      _vm.hasNoPlacedItems
        ? _c(
            "div",
            { staticClass: "placement-hint-overlay" },
            [
              _c(
                "v-card",
                {
                  staticClass: "placement-hint-card",
                  attrs: { elevation: "3" },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mb-2", attrs: { large: "" } },
                        [_vm._v("mdi-information-outline")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-h6 mb-2" }, [
                        _vm._v(_vm._s(_vm.$t("placement_hint.title"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-body-2" }, [
                        _vm._v(
                          _vm._s(_vm.$mpt(_vm.$t("placement_hint.description")))
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.capturePlacementMode
        ? _c("div", { staticClass: "placement-mode-banner" }, [
            _c(
              "div",
              { staticClass: "placement-mode-banner__main" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "placement-mode-banner__icon",
                    attrs: { size: 20 },
                  },
                  [_vm._v("touch_app")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "placement-mode-banner__title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("placement_mode.message")) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "svg",
        {
          ref: "svg",
          class: [
            "floor-plan-svg",
            { "floor-plan-svg--dragging": _vm.isDragging },
          ],
          attrs: {
            viewBox: _vm.viewBox,
            "data-testid": "floor-plan-svg",
            role: "img",
            "aria-label": _vm.$t("floor_plan_canvas"),
          },
          on: {
            dragover: function ($event) {
              $event.preventDefault()
            },
            drop: _vm.handleDrop,
            mousemove: _vm.handleMouseMove,
            mouseup: _vm.handleMouseUp,
            mouseleave: _vm.handleMouseUp,
          },
        },
        [
          _vm._l(_vm.placedItems, function (item) {
            return _c(
              "g",
              {
                key: item.itemId,
                staticClass: "item-group",
                attrs: {
                  "data-testid": "item-group-" + item.itemId,
                  opacity:
                    item.status === "inactive" ? _vm.INACTIVE_OPACITY : 1,
                },
                on: {
                  mouseenter: function ($event) {
                    return _vm.handleItemMouseEnter($event, item)
                  },
                  mouseleave: _vm.handleItemMouseLeave,
                },
              },
              [
                _vm.isCircleVisible
                  ? _c("bubble-circle", {
                      attrs: {
                        cx: item.coordinates.x,
                        cy: item.coordinates.y,
                        count: item.count,
                        "min-radius": _vm.minCircleRadius,
                        "max-radius": _vm.maxCircleRadius,
                        "circle-scale-max": _vm.circleScaleMax,
                        "data-testid": "bubble-circle",
                        "aria-label": _vm.$t("bubble_label", {
                          label: item.label,
                          count: item.count,
                        }),
                      },
                      on: {
                        mousedown: function ($event) {
                          return _vm.handleMouseDown($event, item.itemId)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("arrow-marker", {
                  attrs: {
                    x: item.coordinates.x,
                    y: item.coordinates.y,
                    rotation: item.coordinates.rotation || 0,
                    "marker-size": _vm.markerSize,
                    "size-scale": _vm.sizeScale,
                    color: item.color,
                    rotating: _vm.rotatingItem === item.itemId,
                    "is-exporting": _vm.isExporting,
                    "aria-label": _vm.$t("marker_label", { label: item.label }),
                  },
                  on: {
                    mousedown: function ($event) {
                      return _vm.handleMouseDown($event, item.itemId)
                    },
                    "rotation-start": function ($event) {
                      return _vm.startRotation($event, item)
                    },
                  },
                }),
                _vm._v(" "),
                _c("marker-label", {
                  attrs: {
                    x: _vm.labelX(item),
                    y: item.coordinates.y,
                    label: item.label,
                    count: item.count,
                    "size-scale": _vm.sizeScale,
                    "show-name": _vm.isLabelVisible,
                    "show-count": _vm.isCountVisible,
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm._l(_vm.placedCaptureItems, function (captureItem) {
            return _c(
              "g",
              {
                key: "capture-" + captureItem.id,
                attrs: {
                  "data-testid": "capture-pin",
                  transform:
                    "translate(" +
                    captureItem.coordinates.x +
                    "," +
                    captureItem.coordinates.y +
                    ")",
                },
                on: {
                  mousedown: function ($event) {
                    return _vm.handleCaptureMouseDown($event, captureItem)
                  },
                  click: function ($event) {
                    return _vm.handleCaptureClick(captureItem)
                  },
                },
              },
              [
                _c("title", [
                  _vm._v(_vm._s(_vm.captureTooltipText(captureItem))),
                ]),
                _vm._v(" "),
                _c("g", { staticClass: "capture-pin-inner" }, [
                  _c("circle", {
                    staticClass: "capture-pin-circle",
                    attrs: {
                      r: _vm.pinRadius,
                      fill: "#7b1fa2",
                      stroke: "#333",
                      "stroke-width": "2",
                      "data-testid": "capture-pin-circle",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        x: -_vm.iconHalfSize,
                        y: -_vm.iconHalfSize,
                        width: _vm.iconSize,
                        height: _vm.iconSize,
                        viewBox: "0 -960 960 960",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { d: _vm.rodentIconPath, fill: "#fff" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("circle", {
                    staticClass: "capture-pin-badge",
                    attrs: {
                      cx: _vm.badgeOffset,
                      cy: -_vm.badgeOffset,
                      r: _vm.badgeRadius,
                      fill: "#e53935",
                      stroke: "#fff",
                      "stroke-width": "1.5",
                      "data-testid": "capture-pin-badge",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.badgeOffset,
                        y: -_vm.badgeOffset,
                        "text-anchor": "middle",
                        "dominant-baseline": "central",
                        "font-size": _vm.badgeFontSize,
                        fill: "#fff",
                        "font-weight": "700",
                        "font-family": "sans-serif",
                      },
                    },
                    [_vm._v(_vm._s(captureItem.count))]
                  ),
                ]),
              ]
            )
          }),
          _vm._v(" "),
          _vm.capturePlacementMode
            ? _c("rect", {
                staticStyle: { cursor: "crosshair" },
                attrs: {
                  width: _vm.imageDimensions.width,
                  height: _vm.imageDimensions.height,
                  fill: "transparent",
                  "data-testid": "capture-placement-overlay",
                },
                on: { click: _vm.handlePlacementClick },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("export-info", {
            attrs: {
              "place-name": _vm.placeName,
              "floor-plan-name": _vm.floorPlan.name,
              "selected-month": _vm.selectedMonth,
              "detection-filter": _vm.detectionFilter,
              "size-scale": _vm.sizeScale,
            },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "floor-plan-legend" },
        [
          _c("sensor-type-legend", {
            attrs: { sensors: _vm.sensors, "is-exporting": _vm.isExporting },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("histogram-popup", {
        attrs: {
          "histogram-data": _vm.hoveredItemHistogramData,
          "item-label": _vm.hoveredItem ? _vm.hoveredItem.label : "",
          "position-x": _vm.popupPosition.x,
          "position-y": _vm.popupPosition.y,
        },
        model: {
          value: _vm.showPopup,
          callback: function ($$v) {
            _vm.showPopup = $$v
          },
          expression: "showPopup",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }